import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { message, Col, Row, Button, Divider, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { URL } from "../00_Nav/url";
// component
import BranchAccessPOS from "./component/branch_access_pos";
import BranchAccessShop from "./component/branch_access_shop";
// redux
import {
  updateAccessShop,
  snapDetail,
  unSnapDetail,
} from "../../store/branch/branch.action";
import { detailSelector } from "../../store/branch/branch.selector";
import {
  snapStaffs,
  unSnapStaffs,
  getStaffByIds,
  emptyStaffs,
  updatePosAccessStaff,
} from "../../store/staff/staff.action";
import { staffSelector, infosSelector } from "../../store/staff/staff.selector";
import "./style.css";

const BranchAccess = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const id = params?.id || "";
  // -------------------------- STATE --------------------------
  const [shopStaffs, setShopStaffs] = useState([]);
  const [posStaffs, setPosStaffs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const staffs = useSelector(staffSelector);
  const infoStaff = useSelector(infosSelector);
  const detail = useSelector(detailSelector);

  // -------------------------- FUNCTION --------------------------
  const handleAdd = (posStaff) => {
    if (!posStaffs.includes(posStaff)) {
      setPosStaffs([...posStaffs, posStaff]);
    }
  };

  const handleRemove = (id) => {
    const removed = posStaffs?.filter((item) => item !== id);
    setPosStaffs(removed);
  };

  const handleAddShop = (shopStaff) => {
    if (!shopStaffs.includes(shopStaff)) {
      setShopStaffs([...shopStaffs, shopStaff]);
    }
  };

  const handleRemoveShop = (id) => {
    // console.log("id", id);
    const removed = shopStaffs?.filter((item) => item !== id);
    setShopStaffs(removed);
  };

  const handleSave = () => {
    // Save the shop Staff
    if (id !== "" && shopStaffs) {
      setLoading(true);
      dispatch(
        updateAccessShop({ branchId: id, coop: shopStaffs }, (response) => {
          setLoading(false);
          if (response.status === 200) {
            message.success("Grand Access Successfully!");
            setEdit(false);
          } else {
            message.error(response.data || "Error! Please try again!");
          }
        })
      );
    }

    // Save the Pos Staff
    if (id !== "" && posStaffs) {
      setLoading(true);
      dispatch(
        updatePosAccessStaff({ staffs: posStaffs, branch: id }, (response) => {
          if (response.status === 200) {
            console.log({ response });
            setEdit(false);
          } else {
            message.error(response.data || "Error! Please try again!");
          }
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (id !== "") {
      dispatch(snapStaffs({ branch: id }));
      dispatch(snapDetail({ id }));
    }

    return () => {
      dispatch(unSnapStaffs());
      dispatch(unSnapDetail());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (staffs?.length > 0) {
      //get infostaff

      const ids = staffs?.map((item) => item.staff);
      dispatch(
        getStaffByIds({ ids }, (response) => {
          if (response.status === 500) {
            message.error(response?.data);
          }
        })
      );

      //get the pos = true
      const posStaff = staffs
        ?.filter((item) => item?.pos)
        ?.map((row) => row?.staff);
      setPosStaffs(posStaff);
    } else {
      dispatch(emptyStaffs());
    }
  }, [dispatch, staffs]);

  //import access data
  useEffect(() => {
    if (detail) {
      const coop = detail?.coop || [];
      setShopStaffs(coop);
    }
  }, [detail]);

  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderTitle()}
        <Divider />
        {renderAccessDetails()}
        <Divider />
        {renderAccessShop()}
      </Col>
    );
  };

  const renderTitle = () => {
    return (
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b style={{ fontSize: 18 }}>Grant Access</b>
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          {renderButton()}
        </Col>
      </Row>
    );
  };

  const renderButton = () => {
    if (!edit) {
      return (
        <Button
          loading={loading}
          onClick={() => setEdit(true)}
          style={{ width: 120 }}
          type="primary"
        >
          Edit
        </Button>
      );
    } else {
      return (
        <Space>
          <Button
            loading={loading}
            onClick={() => setEdit(false)}
            style={{ width: 120 }}
          >
            Cancel
          </Button>
          <Button
            loading={loading}
            onClick={handleSave}
            style={{ width: 120 }}
            type="primary"
          >
            Save
          </Button>
        </Space>
      );
    }
  };

  const renderAccessDetails = () => {
    return (
      <Row style={{ width: "100%", padding: "40px 0px" }}>
        <Col lg={8} md={8} sm={24} xs={24}>
          <h1>POS Access</h1>
          <p>Permission for staff to access this shop POS</p>
        </Col>
        <Col lg={16} md={16} sm={24} xs={24}>
          <BranchAccessPOS
            disabled={!edit || loading}
            data={infoStaff}
            posData={posStaffs}
            handleAdd={handleAdd}
            handleRemove={handleRemove}
          />
        </Col>
      </Row>
    );
  };

  const target = infoStaff?.find(
    (s) => s?.id === "4myA02Jf0hP2cYplLVpfN8EmPL43"
  );

  console.log({ target, infoStaff });

  const renderAccessShop = () => {
    return (
      <Row style={{ width: "100%" }}>
        <Col lg={8} md={8} sm={24} xs={24}>
          <h1>Shop Access</h1>
          <p>Permission for people you shared to access your shop portal</p>
        </Col>
        <Col lg={16} md={16} sm={24} xs={24}>
          <BranchAccessShop
            disabled={!edit || loading}
            data={infoStaff}
            shopData={shopStaffs}
            handleAdd={handleAddShop}
            handleRemove={handleRemoveShop}
          />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};

export default BranchAccess;
